import {ComplianceManagerApi} from "../compliance-manager/compliance-manager";
import Override from "components/Override";
import {message} from "antd";

export interface OverridePanelProps {
    api: ComplianceManagerApi
}

export default function OverridePanel(props: OverridePanelProps){

    const { api } = props;

    function onOverridden(){
        api.setDrawerVisibility('overridePanel', false);
    }

    return <Override isnData={api.paxContext?.paxNode} onOverridden={onOverridden} />
}